import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import { Animated, Platform, Pressable, StyleSheet } from "react-native";

export default function PressableContainer(props) {
  const {
    rootStyle = {},
    onMouseEnter,
    onMouseLeave,
    style = {},
    onPress,
    disabled,
    testID,
    accessibilityRole = "button",
    role,
    children,
  } = props;

  const [animatedScale] = useState(() => new Animated.Value(1));

  const popIn = useCallback(() => {
    Animated.timing(animatedScale, {
      toValue: 0.98,
      duration: 50,
      useNativeDriver: true,
    }).start();
  }, [animatedScale]);

  const popOut = useCallback(() => {
    Animated.timing(animatedScale, {
      toValue: 1,
      duration: 100,
      useNativeDriver: true,
    }).start();
  }, [animatedScale]);

  return (
    <Animated.View
      style={[
        rootStyle,
        {
          transform: [{ scale: animatedScale }],
        },
      ]}
    >
      <Pressable
        onPressIn={popIn}
        onPressOut={popOut}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onPress={onPress}
        disabled={disabled}
        testID={testID}
        accessibilityRole={accessibilityRole}
        role={role}
        style={({ hovered, pressed }) => [
          styles.base,
          style,
          hovered && styles.hovered,
          pressed && styles.pressed,
        ]}
      >
        {children}
      </Pressable>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  base: {
    borderRadius: 4,
    padding: 6,
    transitionDuration: "150ms",
    ...Platform.select({
      web: {
        cursor: "pointer",
        userSelect: "none",
        outlineStyle: "none",
      },
    }),
  },
  hovered: {
    opacity: 0.8, // Slightly faded on hover
  },
  pressed: {
    opacity: 0.7, // More faded when pressed
  },
});

PressableContainer.propTypes = {
  rootStyle: PropTypes.object,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  style: PropTypes.object,
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
  testID: PropTypes.string,
  accessibilityRole: PropTypes.string,
  role: PropTypes.string,
  children: PropTypes.node,
};